<div *ngIf="orderReady">
	<!-- Header -->
	<div class="modal-header">
		<div class="title">
		<h2 class="modal-title">Mise à jour de la commande</h2>
		<h3 class="modal-title" style="text-transform: uppercase">N°{{ orderDetails.parentId }}</h3>
		</div>
		<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
		<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<!-- Body  -->
	<div class="modal-body d-flex flex-column ">
		<div class="commande" *ngIf="role !== 'Provider'">
			<h1>{{orderDetails.totalPrice}} {{orderDetails.currencySymbol}}</h1>
			<h6 style="margin-bottom: 1.5rem;">TTC</h6>
		</div>

		<div class="d-flex flex-column w-100">
			<!-- info of client -->
			<div style="margin-left: 100px;">
				<div class="list-grid-2 mb-30">
				<h5>INFORMATION DU CLIENT</h5>
					<div>
						<h6>Paiement par :</h6>
						<p>{{orderDetails.paymentMethodTitle}}</p>
					</div>
					<div>
						<div class="mb-20">
							<h6>Identifiant :</h6>
							<p>N°{{orderDetails.clientId}}</p>
						</div>
						<div class="mb-20">
							<h6>Nom et prénom :</h6>
							<p>{{orderDetails.billing.last_name}} {{orderDetails.billing.first_name}}</p>
						</div>
					</div>
				</div>
			</div>
		
			<!-- BTN de gestion -->
			<div class="d-flex flex-row flex-jc-c btn_container mb-30">
				<div class="d-flex flex-column flex-ai-c">
					<button type="button" [class.active]="selectedOrderRefused" class="btn_bo btn btn-red" [disabled]="btn_order_refused" (click)="orderRefused()">
						<i class="fa fa-times-circle"></i>
						Refuser commande
					</button>
                    <button type="button" [class.active]="selectedBlocageUsine" class="btn_bo btn btn-orange" [disabled]="btn_blocage_usine" (click)="orderBlocageUsine()">
						<i class="fa fa-times-circle"></i>
						Blocage usine
					</button>
                
					<button type="button" [class.active]="selectedOrderDelivered" class="btn_bo btn btn-green" [disabled]="btn_order_delivered" (click)="orderDelivered()">
						<i class="fa fa-check-square-o"></i>
						Commande livrée
					</button>
				</div>
				<div class="d-flex flex-column flex-ai-c">
                    <button type="button" [class.active]="selectedCancelOrder" class="btn_bo btn btn-red" [disabled]="btn_cancel_order" (click)="orderCancelled()">
						<i class="fa fa-times-circle"></i>
						Finaliser en boutique
					</button>
                    <button type="button" [class.active]="selectedBlocageMetrage" class="btn_bo btn btn-orange" [disabled]="btn_blocage_metrage" (click)="orderBlocageMetrage()">
						<i class="fa fa-times-circle"></i>
						Blocage métrage
					</button>
					<button type="button" [class.active]="selectedPaymentReceived" class="btn_bo btn btn-green" [disabled]="btn_payment_received" (click)="paymentReceived()">
						<i class="fa fa-check-square-o"></i>
						Valider commande
					</button>
        
                    <button type="button" [class.active]="selectedOrderSent" class="btn_bo btn btn-primary" [disabled]="btn_order_sent" (click)="orderSent()">
						<i class="fa fa-paper-plane-o"></i>
                        Commande expédié
					</button> 
					<!-- <button type="button" [class.active]="selectedPaymentRefused" class="btn_bo btn btn-orange" [disabled]="btn_payment_refused" (click)="paymentRefused()">
						<i class="fa fa-times-circle"></i>
						Paiement refusé / non reçu
					</button> -->
				</div>

			</div>
			
			<form (ngSubmit)="sendAction(currentAction, form.value)" #form="ngForm">
				<div class="row" *ngIf="displayTextarea">
					<div class="col">
						<div class="form-group mb-0">
							<textarea ngModel name="textarea" class="form-control" rows="3" placeholder="Justifier le problème..."></textarea>
						</div>
					</div>
				</div>
				<div *ngIf="displayFooterBtn" class="modal-footer d-flex flex-row flex-jc-sa">
					<button type="reset" class="btn_bo btn btn-danger btn_bo" (click)="cancelChange()">Annuler</button>
					<button type="submit" class="btn_bo btn btn-success btn_bo">Valider</button>
				</div>
			</form>
		</div>
	</div>
</div>